import {
  Datagrid,
  ExportButton,
  FunctionField,
  List,
  Pagination,
  TextInput,
  TopToolbar,
} from "react-admin";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { ListPageIndicator } from "../../components/TablePageIndicator";
import { csvExporter } from "../../components/csvExporter";
import {
  datagridSx,
  listCardWithToolbarSx,
  rowTitleSx,
} from "../../components/listStyles";

// O "Novo" do breadcrumb cobre a criação — o "Criar" da toolbar repetia
// a mesma ação
const ListActions = () => (
  <TopToolbar sx={{ alignItems: "center" }}>
    <ExportButton />
    <ListPageIndicator />
  </TopToolbar>
);

const filters = [
  <TextInput label="Buscar por nome" source="name" alwaysOn resettable />,
];

const exporter = csvExporter("divisoes-tecnicas", {
  ID: (r) => r.id,
  Nome: (r) => r.name,
});

// Padrão das Categorias de Sócios: clicar na linha abre a ficha;
// Editar/Excluir visíveis (antes ficavam atrás do menu "⋮"). Ordem
// alfabética por padrão — a API desta tela ordena pelo nome.
export const TechDivisionList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Divisões Técnicas"
        firstPath="/#/technical-divisions/crud"
        actionType="create"
      />
      <List
        filters={filters}
        actions={<ListActions />}
        exporter={exporter}
        sort={{ field: "name", order: "ASC" }}
        perPage={25}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
        // Mantém a página atual visível enquanto a próxima carrega
        queryOptions={{ keepPreviousData: true }}
        sx={listCardWithToolbarSx}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={datagridSx}
        >
          <FunctionField
            label="Divisão Técnica"
            sortBy="name"
            render={(record: any) => (
              <Typography component="span" sx={rowTitleSx}>
                {record.name}
              </Typography>
            )}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
